export const smsLogsConstants = {
    GET_SMS_LOG_DATA_REQUEST: 'GET_SMS_LOG_DATA_REQUEST',
    GET_SMS_LOG_DATA_SUCCESS: 'GET_SMS_LOG_DATA_SUCCESS',
    GET_SMS_LOG_DATA_FAILURE: 'GET_SMS_LOG_DATA_FAILURE',
}